import { useSingleEntity } from 'modules/domain/common/hooks'
import { endpoints } from 'modules/endpoints'
import { FC, useEffect } from 'react'
import { SampleDetailed, SampleWithRequests } from 'views/pages/Samples/types'
import { PublishLocalForm } from './PublishLocalForm'
import { Spinner } from 'views/components/CommonTableComponents/CommonTableComponents'
import { ASharedModal, SharedModalTitle } from 'views/components/SharedModal'
import { useTranslation } from 'react-i18next'
import { Progress } from '@agro-club/agroclub-shared'
import { Card } from 'views/components/Card/Card'
import { AButton } from 'views/components/Analytics'
import { SampleDataForBotFromHistory } from '../../../types'

type Props = {
  sample: SampleDetailed | SampleWithRequests
  onSuccess: () => Promise<void>
  onClose: () => void
  setShowHistoryData: (show: boolean) => void
}

export const PrevPublishedToLocalModal: FC<Props> = ({ onSuccess, sample, onClose, setShowHistoryData }) => {
  const { t } = useTranslation('samples')
  const [progress, data] = useSingleEntity<SampleDataForBotFromHistory>(
    endpoints.samplesDataForLocalBotFromHistory(sample.id.toString()),
  )

  useEffect(() => {
    if (progress !== Progress.SUCCESS) return
    if (!data) setShowHistoryData(false)
  }, [progress, data, setShowHistoryData])

  let content

  if (!data) {
    content = (
      <div
        style={{
          height: 300,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Spinner />
      </div>
    )
  } else {
    content = (
      <PublishLocalForm
        data={data}
        onSuccess={onSuccess}
        docs={data.selected_files}
        selectAllFiles
        onClose={onClose}
        sample={sample}
      >
        <Card.Container intent="warning" style={{ marginBottom: 10 }}>
          <Card.GapableContent>
            {t('dataFromHistoryWarning')}
            <div>
              <AButton color="secondary" id="returnToRegularMode" onClick={() => setShowHistoryData(false)}>
                {t('returnToInitalData')}
              </AButton>
            </div>
          </Card.GapableContent>
        </Card.Container>
      </PublishLocalForm>
    )
  }

  return (
    <ASharedModal size="medium" onClose={onClose} id="telegramPreview">
      <SharedModalTitle>{t('sendToLocalChat')}</SharedModalTitle>
      {content}
    </ASharedModal>
  )
}
